export enum LogLevel {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Debug = 'debug',
  None = 'none',
}

export default LogLevel;
